import { createRelayResource } from '@townsquare/relay-utils';
import type { ResourceContext } from '@townsquare/router/types';

import SavedViewUpdatesQuery, {
	type SavedViewUpdatesQuery as SavedViewUpdatesQueryType,
} from '../SavedViewUpdates/__generated__/SavedViewUpdatesQuery.graphql';

export const savedViewUpdatesResource = createRelayResource<SavedViewUpdatesQueryType>({
	getQuery: (routerContext, resourceContext) => {
		const context = resourceContext as ResourceContext;

		return {
			query: SavedViewUpdatesQuery,
			variables: {
				workspaceUuid: context.workspace?.UUID || '',
				viewUuid: routerContext.match.params.uuid || '',
			},
			options: {
				fetchPolicy: 'store-and-network',
			},
		};
	},
});
